import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { forgotPasswordSchema } from '@/schemas/auth.schema';
import FormField from '@/pages/auth/components/FormField';
import { useForgotPassword } from '@/hooks/useForgotPassword';
import './Register.scss';
import AuthLayout from '@/layouts/AuthLayout';
import { Button } from 'antd';

const ForgotPassword = () => {
    const { loading, requestError, successEmail, handleForgotPassword } = useForgotPassword();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({ resolver: zodResolver(forgotPasswordSchema) });

    if (successEmail) {
        return (
            <div className="form-success-state">
                <CheckCircle size={48} color="#16a34a" strokeWidth={1.5} />
                <h3>Check your email</h3>
                <p>
                    We sent a password reset link to <strong>{successEmail}</strong>.
                    Check your inbox and follow the instructions.
                </p>
                <Link to="/login" className="auth-submit-btn" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ArrowLeft size={15} />
                    Back to Sign In
                </Link>
            </div>
        );
    }

    return (
        <AuthLayout>
            <h4>Forgot your password?</h4>
            <form onSubmit={handleSubmit(handleForgotPassword)} noValidate>

                {requestError && (
                    <div className="form-error" role="alert">{requestError}</div>
                )}

                <FormField label="Email Address" error={errors.email?.message} icon={Mail}>
                    <input
                        {...register('email')}
                        type="email"
                        placeholder="Enter your registered email"
                        className="field-input"
                        autoComplete="email"
                        autoFocus
                    />
                </FormField>

                <Button type="primary" htmlType="submit" className="auth-submit-btn">
                    {loading ? 'Sending...' : 'Send Reset Link'}
                </Button>

                <div className="auth-footer">
                    <Link to="/login" className="auth-footer-text">
                        <ArrowLeft size={13} style={{ display: 'inline', marginRight: '4px' }} />
                        <span>Back to Sign In</span>
                    </Link>
                </div>

            </form>
        </AuthLayout>
    );
};

export default ForgotPassword;